import { usePayment } from '$api-clients/hooks';
import { useCompensationReportFilters } from '../CompensationReportFilters/CompensationReportFilters.helpers';
import { buildReportingSummaryQuery } from '../helpers';
import { useAllTimeStartDate } from '../ReportsConfiguration/useReportsConfiguration';

export function usePayoutSummary({ viewReportAs }: { viewReportAs: string }) {
  const { filters } = useCompensationReportFilters();
  const allTimeStartDate = useAllTimeStartDate();
  const query = buildReportingSummaryQuery(
    filters,
    viewReportAs,
    allTimeStartDate,
  );
  const { data: payoutSummary, isLoading } = usePayment('/reporting/summary', {
    params: {
      query: {
        ...query,
        limit: 1,
        offset: 0,
      },
    },
  });

  const result = payoutSummary?.results[0];
  const weightedAdjustedGrossCommission =
    result?.weightedAdjustedGrossCommission ?? null;
  const weightedStartingGrossCommission =
    result?.weightedStartingGrossCommission ?? null;

  const preSplitDeductions =
    weightedAdjustedGrossCommission != null &&
    weightedStartingGrossCommission != null
      ? weightedAdjustedGrossCommission - weightedStartingGrossCommission
      : null;

  return {
    isLoading,
    noResults: payoutSummary?.results.length === 0,
    weightedAdjustedGrossCommission,
    weightedStartingGrossCommission,
    preSplitDeductions,
    agentGrossShare: result?.agentGrossShare ?? null,
    agentFeesReceived: result?.agentFeesReceived ?? null,
    agentFeesPaid: result?.agentFeesPaid ?? null,
    agentNetShare: result?.agentNetShare ?? null,
    brandGrossShare: result?.brandGrossShare ?? null,
    brandFeesReceived: result?.brandFeesReceived ?? null,
    brandFeesPaid: result?.brandFeesPaid ?? null,
    brandNetShare: result?.brandNetShare ?? null,
    teamGrossShare: result?.teamGrossShare ?? null,
    teamFeesReceived: result?.teamFeesReceived ?? null,
    teamFeesPaid: result?.teamFeesPaid ?? null,
    teamNetShare: result?.teamNetShare ?? null,
  };
}
